<template>
  <div>
    <div v-if="tipoPerfil == 8" class="mb-2 text-right">
      <v-btn class="rounded-sm font-weight-regular" color="cyan" dark :to="{ name: 'registro-notificacao-cadastro' }">Novo</v-btn>
    </div>

    <v-alert type="error" color="error" v-if="$v.form.$invalid && $v.form.$dirty" :value="true">
      <div>Atenção: Verifique os campos obrigatórios, antes de iniciar a busca.</div>
    </v-alert>

    <v-alert type="error" style="color: white;" v-if="nadaEncontrado && buscando == false" :value="true">
      <div>Nenhuma notificação cadastrada!</div>
    </v-alert>

    <v-alert color="info" icon="info" v-if="buscando" :value="true">
      <div class="text--white">Por favor, aguarde! Realizando a busca...</div>
    </v-alert>

    <br/>

    <form @submit.prevent="buscar">
      <v-layout wrap>
        <v-flex xs12 sm6 md4>
          <Select label="Ano letivo*" :disabled="loading" :options="optionsAnos" v-model="form.aaletivo" :v="$v.form.aaletivo" @change="$refs.turmas.limpar();" />
        </v-flex>
        <v-flex xs12 sm6 md4>
          <select-ajax
            label="Turma"
            :disabled="loading || form.aaletivo == '-1'"
            rota='ei/turma/select-turmas-perfil'
            :params="{ cdtipesc:form.cdtipesc, cdescola:form.cdescola, cdpessoal:form.cdpessoalautor, cdmatric:form.cdmatricautor, aaletivo:form.aaletivo, identificadorperfilatual:userDadosPerfilAtual.identificadorperfil }"
            contador
            opcaoTodos="Todas"
            ref="turmas"
            chave="cdturma"
            :valor="(item) => `${item.nmturma} ${item.horario ? ' - ' + item.horario : ''}`"
            v-model="form.cdturma"
            :v="$v.form.cdturma"
            @change="$refs.disciplinas.limpar(); $refs.periodos.limpar();">
          </select-ajax>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <select-ajax
            label="Disciplina/Campo de Experiência"
            :disabled="loading || form.cdturma == '' || form.cdturma == '-1'"
            rota='ei/disciplina/select-disciplinas-perfil-periodo'
            :params="{ cdtipesc:form.cdtipesc, cdescola:form.cdescola, cdpessoal:form.cdpessoalautor, cdmatric:form.cdmatricautor, aaletivo:form.aaletivo, cdturma:form.cdturma, identificadorperfilatual:userDadosPerfilAtual.identificadorperfil }"
            :resultado='["disciplinas"]'
            contador
            opcaoTodos="Todas"
            ref="disciplinas"
            chave="cddiscipl"
            valor="dsdiscipl"
            v-model="form.cddiscipl"
            :v="$v.form.cddiscipl"
            @change="tipoPerfil != 2 ? $refs.professores.limpar() : '';">
          </select-ajax>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <select-ajax
            label="Período Avaliativo"
            :disabled="loading || form.cdturma == '' || form.cdturma == '-1'"
            rota='ei/disciplina/select-disciplinas-perfil-periodo'
            :params="{ cdtipesc:form.cdtipesc, cdescola:form.cdescola, cdpessoal:form.cdpessoalautor, cdmatric:form.cdmatricautor, aaletivo:form.aaletivo, cdturma:form.cdturma, identificadorperfilatual:userDadosPerfilAtual.identificadorperfil }"
            :resultado='["periodos"]'
            contador
            opcaoTodos="Todos"
            ref="periodos"
            chave="cdpravadi"
            valor="dspravadi"
            v-model="form.cdpravadi"
            :v="$v.form.cdpravadi">
          </select-ajax>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <select-ajax
            label="Atribuído"
            :disabled="loading || tipoPerfil == 2 || form.cddiscipl == '' || form.cddiscipl == '-1'"
            rota='ei/professor/select-professor-por-turma-disciplina'
            :params="{ aaletivo:form.aaletivo, cdtipesc:form.cdtipesc, cdescola:form.cdescola, cdturma:form.cdturma, cddiscipl:form.cddiscipl }"
            :listaLocal="tipoPerfil == 2 ? [{ key: form.cdpessoalatribuido + '-' + form.cdmatricatribuido, value: form.cdmatricatribuido + ' - ' + username }] : null"
            contador
            opcaoTodos="Todos"
            ref="professores"
            :chave="(item) => `${item.cdpessoal}-${item.cdmatric}`"
            :valor="(item) => `${item.cdmatric} - ${item.nmfuncion}`"
            v-model="atribuido"
            :v="$v.form.cdmatricatribuido">
          </select-ajax>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <Select :label="`Situação (${ optionsSituacoes.length == 0 ? optionsSituacoes.length : optionsSituacoes.length - 1 })`" :disabled="loading" :options="optionsSituacoes" v-model="form.indicasituacaonotificacao" :v="$v.form.indicasituacaonotificacao" />
        </v-flex>
        <v-flex xs12>
          <Input type="text" label="Descrição da Notificação" :disabled="loading" v-model="form.descricaonotificacao" :v="$v.form.descricaonotificacao" />
        </v-flex>
        <v-flex xs12>
          <Input type="text" label="Descrição da Resposta" :disabled="loading" v-model="form.descricaoresposta" :v="$v.form.descricaoresposta" />
        </v-flex>

        <v-flex xs12>
          <v-btn class="rounded-sm font-weight-regular" :loading="buscando" type="submit" color="cyan" dark>Buscar</v-btn>
        </v-flex>
      </v-layout>
    </form>

    <br/>

    <div class="filtro-bloco-busca v-card" v-if="!buscando">
      <div class="filtro-itens">
        <div>
          <strong>Ano letivo: </strong>
          <span>{{ getLabelFiltro(optionsAnos, this.form.aaletivo) }} </span><br />
          <strong>Turma: </strong>
          <span>{{ form.cdturma == '' ? 'Todas' : getLabel("turmas", form.cdturma) }} </span><br />
          <strong>Disciplina: </strong>
          <span>{{ form.cddiscipl == '' ? 'Todas' : getLabel("disciplinas", form.cddiscipl) }} </span><br />
          <strong>Período Avaliativo: </strong>
          <span>{{ form.cdpravadi == '' ? 'Todos' : getLabel("periodos", form.cdpravadi) }} </span><br />
          <strong>Atribuído: </strong>
          <span>{{ form.cdmatricatribuido == '' || form.cdmatricatribuido == '-1' ? 'Todos' : tipoPerfil == 2 ? `${form.cdmatricatribuido} - ${username}` : getLabel("professores", `${form.cdpessoalatribuido}-${form.cdmatricatribuido}`)}} </span><br />
          <strong>Situação: </strong>
          <span>{{ form.indicasituacaonotificacao == '' ? 'Todas' : getLabelFiltro(optionsSituacoes, this.form.indicasituacaonotificacao) }} </span><br />
        </div>
      </div>
      <div>
        <strong>Resultados Encontrados:</strong> {{ paginaTotal }}
      </div>
    </div>

    <br/>

      <v-card class="mb-5" style="overflow-y: auto" v-for="notificacao in notificacoes" :key="notificacao.identificadornotificacao">

        <table class="table-card">
          <thead>
            <tr style="background-color: #f3f3f3;">
              <th>Ano Letivo</th>
              <th>Turma</th>
              <th>Disciplina</th>
              <th>Período Avaliativo</th>
              <th>{{ tipoPerfil == 2 ? 'Autor' : 'Atribuído' }}</th>
              <th>Situação</th>
              <th>Data de Exibição</th>
              <th>Data da Resposta</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="centro">{{ notificacao.aaletivo }}</td>
              <td class="centro">{{ notificacao.turma ? notificacao.turma.nmturma : '' }}</td>
              <td class="centro">{{ notificacao.disciplina ? notificacao.disciplina.dsdiscipl : '' }}</td>
              <td class="centro">{{ notificacao.periodo_avaliativo ? notificacao.periodo_avaliativo.dspravadi : 'Todos' }}</td>
              <td class="centro">{{ tipoPerfil == 2 ? notificacao.coordenador.nmfuncion : notificacao.professor.nmfuncion }}</td>
              <td class="centro">{{ notificacao.indicasituacaonotificacao == 'R' ? 'Respondido' : 'Pendente' }}</td>
              <td class="centro">{{ notificacao.dataexibicao | formatDataBR }}</td>
              <td class="centro">{{ notificacao.dataresposta | formatDataBR }}</td>
              <td class="centro" style="min-width: 117px;">
                <v-btn class="rounded-sm font-weight-regular" icon title="Editar" :to="{ path: `/registro-notificacao/${notificacao.identificadornotificacao}` }">
                  <v-icon class="btn-acoes-icon">edit</v-icon>
                </v-btn>
                <v-btn class="rounded-sm font-weight-regular" icon title="Excluir" @click="excluir(notificacao.identificadornotificacao, notificacao.indicasituacaonotificacao)">
                  <v-icon color="red">delete_forever</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr>
              <td colspan="9" class="pa-3">
                <span class=font-weight-bold>Notificação: </span>
                <span>{{ notificacao.descricaonotificacao }}</span>
              </td>
            </tr>
            <tr>
              <td colspan="9" class="pa-3">
                <span class=font-weight-bold>Resposta: </span>
                <span>{{ notificacao.descricaoresposta }}</span>
              </td>
            </tr>
          </tbody>
        </table>

      </v-card>
    <div v-if="quantidadePaginas > 1" class="table-siged-page" style="text-align: right">
      <v-pagination @input="buscar( paginaAtual );" v-model="paginaAtual" :length="quantidadePaginas" total-visible="7" />
    </div>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, maxLength, integer } from 'vuelidate/lib/validators';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import SelectAjax from '@/components/SelectAjax'

const NotificacaoRepository = RepositoryFactory.get('notificacao');

export default {
  name: 'registronotificacao',

  components: {
    SelectAjax
  },

  props: {
    buscarPendentes: [Boolean],
  },

  data() {
    return {
      form: {
        aaletivo: new Date().getFullYear(),
        cdtipesc: '',
        cdescola: '',
        cdturma: '',
        cddiscipl: '',
        cdpravadi: '',
        cdpessoalautor: '',
        cdmatricautor: '',
        cdpessoalatribuido: '',
        cdmatricatribuido: '',
        descricaonotificacao: '',
        indicasituacaonotificacao: '-1',
        descricaoresposta: '',
      },
      loading: false,
      nadaEncontrado: false,
      buscando: false,
      notificacoes: [],
      paginaAtual: 1,
      paginaTotal: 0,
      quantidadePaginas: 0,
      snackbar: false,
      submitText: '',
      optionsAnos: [],
      optionsSituacoes: [ { value: '-1', text: 'Todas'}, { value: 'P', text: 'Pendente'}, { value: 'R', text: 'Respondido'} ],
      tipoPerfil: '',
    };
  },

  validations: {
    form: {
        aaletivo: { required, integer },
        cdtipesc: { integer },
        cdescola: { integer },
        cdturma: { maxLength: maxLength(4) },
        cddiscipl: { integer },
        cdpravadi: { maxLength: maxLength(2) },
        cdpessoalautor: { integer },
        cdmatricautor: { integer },
        cdpessoalatribuido: { integer },
        cdmatricatribuido: { integer },
        descricaonotificacao: { maxLength: maxLength(500) },
        descricaoresposta: { maxLength: maxLength(500) },
    },
  },

  async beforeRouteEnter(to, from, next) {
    next(vm => {
      if( to.params.buscarPendentes == true )
      {
        vm.form.aaletivo = -1;
        vm.form.indicasituacaonotificacao = 'P';
      }
    });
  },

  async activated() {
    this.$Progress.finish();

    setTimeout( () => this.$router.push({query: null}), 100);

    if (!this.$attrs.restaurar ) {
      Object.assign(this.$data, this.$options.data.apply(this));
      this.setupInicial();
    }
    else {
      const index = this.notificacoes.findIndex( (n) => n.identificadornotificacao === this.$attrs.notificacao.identificadornotificacao);

      if (this.form.indicasituacaonotificacao == 'P' && this.$attrs.notificacao.indicasituacaonotificacao == 'R') {
        this.notificacoes.splice(index, 1);
        this.paginaTotal -= 1;
        return;
      }

      this.notificacoes[index].descricaonotificacao = this.$attrs.notificacao.descricaonotificacao;
      this.notificacoes[index].dataexibicao = this.$attrs.notificacao.dataexibicao;
      this.notificacoes[index].descricaoresposta = this.$attrs.notificacao.descricaoresposta;
      this.notificacoes[index].dataresposta = this.$attrs.notificacao.dataresposta;
      this.notificacoes[index].indicasituacaonotificacao = this.$attrs.notificacao.indicasituacaonotificacao;
    }
  },

  async mounted() {
    this.setupInicial();
  },

  methods: {
    setupInicial() {
      this.$Progress.finish();

      this.form.cdtipesc = this.school.cdtipesc;
      this.form.cdescola = this.school.cdescola;
      this.form.cdpessoalautor = this.userProfessor.cdpessoal;
      this.form.cdmatricautor = this.userProfessor.cdmatric;

      this.tipoPerfil = this.userDadosPerfilAtual.identificadorperfil;

      if ( this.tipoPerfil == 2 ) {
        this.form.cdpessoalatribuido = this.userProfessor.cdpessoal;
        this.form.cdmatricatribuido = this.userProfessor.cdmatric;
      }

      this.optionsAnos = this.loadAnos();

      if ( this.buscarPendentes ) {
        this.form.aaletivo = -1;
        this.form.indicasituacaonotificacao = 'P';
        this.buscar();
      }
    },

    loadAnos() {
      if (!this.getAnoInicioSistema || !this.getAnoAtualServidor) { return []; }
      let retornoOptions = [ { text: "Todos", value: "-1" } ];
      for (let i = this.getAnoAtualServidor; i >= this.getAnoInicioSistema; i--) {
        retornoOptions.push({ text: i, value: i });
      }
      return retornoOptions;
    },

    getLabelFiltro( lista, fieldValue ) {
      const item = lista.find(item => item.value == fieldValue);
      return item ? item.text : '';
    },

    getLabel( select, chave ) {
    const tmp = this.$refs[select].obterlista();
      return tmp.length ? tmp.find( item => item.key === chave).value : ''
    },

    async buscar( page = 1 ) {
      try {
        this.$v.$touch();

        if ( this.$v.$invalid ) {
          if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
          return;
        }

        this.loading = true;
        this.buscando = true;
        this.notificacoes = [];

        this.$Progress.start();

        let params = {};

        params.cdtipesc = this.form.cdtipesc;
        params.cdescola = this.form.cdescola;
        params.cdpessoalautor = this.form.cdpessoalautor;
        params.cdmatricautor = this.form.cdmatricautor;

        if ( this.form.aaletivo != '' && this.form.aaletivo != '-1' ) {
          params.aaletivo = this.form.aaletivo;

          if ( this.form.cdturma != '' && this.form.cdturma != '-1' ) {
            params.cdturma = this.form.cdturma;

            if ( this.form.cdpravadi != '' && this.form.cdpravadi != '-1' ) params.cdpravadi = this.form.cdpravadi;

            if ( this.form.cddiscipl != '' && this.form.cddiscipl != '-1') {
              params.cddiscipl = this.form.cddiscipl;

              if ( this.form.cdmatricatribuido != '' && this.form.cdmatricatribuido != '-1') {
                params.cdpessoalatribuido = this.form.cdpessoalatribuido;
                params.cdmatricatribuido = this.form.cdmatricatribuido;
              }
            }
          }
        }

        if ( this.tipoPerfil == 2 ) {
          params.cdmatricatribuido = this.form.cdmatricatribuido;
          params.cdpessoalatribuido = this.form.cdpessoalatribuido;
        }

        if ( this.form.indicasituacaonotificacao != '' && this.form.indicasituacaonotificacao != '-1' ) params.indicasituacaonotificacao = this.form.indicasituacaonotificacao;

        if ( this.form.descricaonotificacao != '' ) params.descricaonotificacao = this.form.descricaonotificacao;

        if ( this.form.descricaoresposta != '' ) params.descricaoresposta = this.form.descricaoresposta;

        params.page = this.paginaAtual;

        const response = await NotificacaoRepository.getNotificacoes( params );

        const data = response.data;

        this.paginaAtual = data.results.current_page;
        this.notificacoes = data.results.data;
        this.quantidadePaginas = data.results.last_page;
        this.paginaTotal = data.results.total;

        this.notificacoes.length ? this.nadaEncontrado = false : this.nadaEncontrado = true;

      } catch( error ) {

      }  finally {
        this.$Progress.finish();
        this.loading = false;
        this.buscando = false;
      }
    },

    async excluir( id, situacao ) {
      if ( this.tipoPerfil == 2 ) {
        const confirmar = await this.$sgal({
          title: 'Ação não permitida',
          text: 'Seu perfil de acesso não tem autorização para executar exclusão de registros.',
          type: 'warning',
          buttons: [
            { text: 'Fechar', color: 'red', response: true },
          ],
        });
        if (confirmar) return;
      }
      else if ( this.tipoPerfil == 8 && situacao == 'R' ) {
        const confirmar = await this.$sgal({
          title: 'Ação não permitida',
          text: 'Esta notificação já foi respondida e por isso não pode ser excluída.',
          type: 'warning',
          buttons: [
            { text: 'Fechar', color: 'red', response: true },
          ],
        });
        if (confirmar) return;
      }

      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir permanentemente esta notificação?',
        type: 'warning',
        buttons: [
          { text: 'Excluir', color: 'red', response: true },
          { text: 'Cancelar', color: 'grey', response: false },
        ],
      });

      if( !confirmar ) { return; }

      try {
        const { data } = await NotificacaoRepository.deleteNotificacao( id, { cdtipesc: this.school.cdtipesc, cdescola: this.school.cdescola, cdmatricautor: this.userProfessor.cdmatric, cdpessoalautor: this.userProfessor.cdpessoal} );

        this.submitText = data.message;
        this.snackbar = true;

        if( this.paginaAtual > 1 && this.notificacoes.length == 1) { this.paginaAtual = this.paginaAtual - 1; }

        this.notificacoes = this.notificacoes.filter(item => item.identificadornotificacao !== id);

      } catch( error ) {
        if( error.response ) {
          this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }
    },
  },

  computed: {
    ...mapGetters(['getAnoSistema', 'getAnoAtualServidor', 'getAnoInicioSistema', 'userProfessor', 'school', 'username', 'userDadosPerfilAtual']),
    atribuido: {
      get() {
        return this.form.cdmatricatribuido == -1 ? this.form.cdmatricatribuido : `${this.form.cdpessoalatribuido}-${this.form.cdmatricatribuido}`;
      },
      set(value) {
        if (value === -1 || value === "") {
          this.form.cdpessoalatribuido = '';
          this.form.cdmatricatribuido = value;
          return;
        }
        [this.form.cdpessoalatribuido, this.form.cdmatricatribuido] = value.split('-');
      }
    }
  }
}
</script>

<style lang="scss">

form .layout .input-block {
  width: 100% !important;
}

@media (min-width: 600px) and (max-width: 960px) {
  .flex.sm6:nth-child(odd) { padding-right: 20px; }
}

@media (min-width: 960px) {
  .flex.md4:nth-child(3n+1),
  .flex.md4:nth-child(3n+2) { padding-right: 20px; }
}

.table-card {
  width: 100%;
  max-width: 100%;
  border: 1px solid rgba(0,0,0,.12);
  border-radius: 2px;
  border-collapse: collapse;
  border-spacing: 0;
}
.table-card  thead tr {
  height: 33px;
}

.table-card  thead tr th{
  transition: .3s cubic-bezier(.25,.8,.5,1);
  white-space: normal;
  height: auto!important;
  font-size: 13px;
  color: black;
  padding: 5px 11px;
  text-transform: uppercase;
      }

.table-card  tbody {
  overflow-x: scroll;
}

.table-card  tbody tr  td{
  font-weight: 400;
  font-size: 13px;
  height: 48px;
  padding: 0px 6px;
  text-align: left;
  border: 1px solid rgba(0,0,0,.12);
}
.table-card  tbody tr  td:hover{
  background: rgba(#00A7C8, .36);
}
.table-card  tbody tr  td.centro{
  text-align: center;
}

.filtro-bloco-busca {
  border: 1px solid '#99999';
  background: white;
  padding: 20px;
  border-radius: 4px;
  font-size: 16px;

  .filtro-itens {
    display: flex;
    flex-wrap: wrap;
    div {
      min-width: 300px;
      margin-right: 10px;
    }
  }
}
</style>
